import AdminVaspDetails from './AdminVaspDetails'

export default AdminVaspDetails
